import { c, classy, m } from '@onfido/castor';
import { Icon } from '@onfido/castor-react';
import React, { useEffect, useState } from 'react';
import { useForwardedRef, withRef } from '../../utils';
import { CustomSelect } from './custom';
import { NativeSelect } from './native';
import { SelectProvider } from './useSelect';
/**
 * `Select` uses an `Icon` that requires `Icons` (SVG sprite) to be included in
 * your app.
 *
 * https://github.com/onfido/castor-icons#use-with-plain-code
 */
export const Select = withRef(function Select({ borderless, className, native, onChange, ...restProps }, ref) {
    const { defaultValue, value } = restProps;
    const selectRef = useForwardedRef(ref);
    const [empty, setEmpty] = useState(!(value !== null && value !== void 0 ? value : defaultValue));
    const [open, setOpen] = useState(false);
    // on every re-render, check for "empty" just after a DOM cycle
    useEffect(() => void setTimeout(() => { var _a; return setEmpty(!((_a = selectRef.current) === null || _a === void 0 ? void 0 : _a.value)); }));
    useEffect(() => {
        if (value != null)
            setEmpty(!value);
    }, [value]);
    return (React.createElement("div", { className: classy(c('select'), m({ borderless, empty, open }), className) },
        React.createElement(SelectProvider, { value: { native } },
            React.createElement(Content, { ...restProps, ref: selectRef, borderless: borderless, native: native, open: open, onChange: (event) => {
                    setEmpty(!event.currentTarget.value);
                    onChange === null || onChange === void 0 ? void 0 : onChange(event);
                }, onOpenChange: setOpen }),
            React.createElement(Icon, { name: "chevron-down", "aria-hidden": "true" }))));
});
const Content = withRef(function Content({ borderless, native, open, onOpenChange, ...restProps }, ref) {
    if (native)
        return React.createElement(NativeSelect, { ...restProps, ref: ref });
    return (React.createElement(CustomSelect, { ...restProps, ref: ref, borderless: borderless, open: open, onOpenChange: onOpenChange }));
});
//# sourceMappingURL=select.js.map